export default __webpack_public_path__ + "static/media/techCoin.c479a498.svg";